import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  prijem: PropTypes.string.isRequired,
  splatka: PropTypes.string.isRequired,
  ucelUveru: PropTypes.string.isRequired,
  vyseuveru: PropTypes.string.isRequired,
};

export default function ExtendedForm(props) {
  const {
    onChange,
    vyseuveru,
    ucelUveru,
    prijem,
    splatka,
  } = props;

  return (
    <React.Fragment>
      <TextField
        id='vyseuveru'
        label='Požadovaná výše úvěru'
        multiline
        rowsMax='4'
        value={vyseuveru}
        onChange={onChange('vyseuveru')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <p>Účel úvěru:</p>
      <StyledRadioGroup
        aria-label='ucelUveru'
        name='ucelUveru'
        value={ucelUveru}
        onChange={onChange('ucelUveru')}
      >
        <FormControlLabel
          value='rekonstrukce'
          control={<Radio color='primary' />}
          label='Rekonstrukce'
          labelPlacement='start'
        />
        <FormControlLabel
          value='koupe'
          control={<Radio color='primary' />}
          label='Koupě'
          labelPlacement='start'
        />
      </StyledRadioGroup>
      <TextField
        id='prijem'
        label='Měsíční příjem do fondu oprav:'
        value={prijem}
        onChange={onChange('prijem')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
      <TextField
        id='splatka'
        label='Maximální výše měsíční splátky:'
        value={splatka}
        onChange={onChange('splatka')}
        variant='outlined'
        fullWidth
        margin='dense'
      />
    </React.Fragment>
  );
}

ExtendedForm.propTypes = propTypes;

const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row !important;
  justify-content: space-around;
  align-items: center;
`;
